var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleLogin',{class:_vm.getClass,attrs:{"disabled":_vm.disabled,"params":_vm.params,"onSuccess":_vm.onSuccess,"onFailure":_vm.onFailure}},[_vm._v(" Login with Google")])}
var staticRenderFns = []

export { render, staticRenderFns }